import React from "react";
import { Compass, SlidersHorizontal, BookOpen, Sparkles, HeartHandshake } from "lucide-react";
import { WHY_US } from "../../../data/sitePages";

const ICONS = [Compass, SlidersHorizontal, BookOpen, Sparkles, HeartHandshake];

export const WhyUs = () => (
  <section data-testid="why-us" className="bg-brand-ink text-white">
    <div className="mx-auto max-w-[1400px] px-6 py-24 md:px-10 md:py-28">
      <div className="mb-12">
        <p className="overline text-white/60">Section 04</p>
        <h2 className="mt-3 font-display text-3xl leading-tight md:text-5xl">Why use YogaToYacht</h2>
      </div>
      <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-3 md:gap-x-12 md:gap-y-14">
        {WHY_US.map((item, i) => {
          const Icon = ICONS[i % ICONS.length];
          return (
            <div key={item.title} data-testid={`why-item-${i}`}>
              <Icon size={22} className="text-brand-terracotta" />
              <h3 className="mt-4 font-display text-xl leading-tight">{item.title}</h3>
              <p className="mt-2 text-sm text-white/70">{item.text}</p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default WhyUs;
